import ReviewContractTermEdits from './ReviewContractTermEdits';

export default ReviewContractTermEdits;
